import { makeApiRequest } from 'actions/api';
import { GET_PREVIOUSLY_ORDERED_MENU_MEALS } from 'lib/constants/v3Actions';
import RequestService from 'services/RequestService';

export const getPreviouslyOrderedMenuMeals = (menuSlug, mealPlanSlug) =>
  makeApiRequest({
    requestType: GET_PREVIOUSLY_ORDERED_MENU_MEALS,
    method: RequestService.v3.getPreviouslyOrderedMenuMeals,
    params: { menuSlug, mealPlanSlug },
  });
